import { html, unsafeCSS } from 'lit';

import { styles as globalStyles } from '~/ui/scss/main.styles';
import { styles } from './module.styles';
import { DERElement } from '~/common/der-element';

export class ModuleWrapper extends DERElement {
    static override styles = [unsafeCSS(globalStyles), unsafeCSS(styles)];

    override render() {
        return html`
            <div class="o-module">
                <slot></slot>
            </div>
        `;
    }
}
